import { PrestationRaw } from "@/types/responses"

const isHS = (prest: PrestationRaw): boolean => {
	return prest.codePackage === "HS"
}

export default isHS
